import Modal from '../../../core/components/Modal/Modal';
import Typography from '../../../core/components/Typography/Typography';
import React, { useEffect, useState } from 'react';
import { InfoMessageService, TranslationService } from '../../../core/services';
import classNames from 'classnames';
import styles from './PuzzelChat.module.scss';
import PuzzleChatApi from './api/PuzzleChatApi';
import { Loader, ModuleContainer } from '../../../core/components';
import withAbortRequest, { AbortRequestPropsType } from '../../../core/hoc/withAbortRequest';
import { useQuery } from 'react-query';
import { ActionStatusType } from '../../../core/types/ActionStatusType';
import { UpdateMessagesType } from './types/UpdateMessagesType';
import PuzzelChatService from './services/PuzzelChatService';

type PropsType = {
  isShowing: boolean;
  disableChat: () => void;
  onClose: () => void;
  onCloseChat: () => void;
};

type CaseType = {
  balanceAmount: string;
  caseNo: string;
  caseDisplayNo: string;
  currency: string;
  sourceTenantId: string;
};

type CasesType = {
  cases: CaseType[];
  displayAllCasesOption: boolean;
};

type ChatType = {
  chatId: string | null;
  customerKey: string | null;
  isEnabled: boolean | null;
  languageCode: string | null;
  nickName: string | null;
  predatorAllCasesCode: string | null;
  predatorSingleCaseCode: string | null;
  queueKey: string | null;
  timeId: string | null;
  visualQueueId: string | null;
};

type ChatRequestType = {
  caseNo: string;
  sourceTenantId: string;
};

const PuzzelChat = (props: PropsType & AbortRequestPropsType) => {
  let intervalOnChatUpdate: any = null;
  let intelecomMsgPnlElChildrenLegth = 1;

  const [chatRequest, setChatRequest] = useState<ChatRequestType>({
    caseNo: '',
    sourceTenantId: '',
  });

  const puzzelChatCases = useQuery<ActionStatusType<CasesType>>(
    'puzzelChatCases',
    () => PuzzleChatApi.getAllCases(props.cancelTokenSource.token),
    {
      enabled: props.isShowing,
      refetchOnWindowFocus: false,
      onError: () => {
        InfoMessageService.error(TranslationService.translate('GeneralErrorMsg'));
      },
    }
  );

  const chatSettings = useQuery<ActionStatusType<ChatType>>(
    ['chatSettings', chatRequest],
    () => PuzzleChatApi.getChat(chatRequest.caseNo, chatRequest.sourceTenantId),
    {
      enabled: !!chatRequest.caseNo.length,
      refetchOnWindowFocus: false,
      onSuccess: (result) => {
        if (result.data.isEnabled) {
          initalizeChat(result.data);
        }
      },
      onError: () => {
        InfoMessageService.error(TranslationService.translate('GeneralErrorMsg'));
      },
    }
  );

  const onChatStartHandle = async (chatConfiguration: ChatType) => {
    if (localStorage.getItem('isChatRunning') === 'true') {
      const unik = localStorage.getItem('chatNoteUnik');
      if (unik) {
        onChatUpdate(JSON.parse(unik));
      }
    } else {
      if (
        chatRequest.sourceTenantId &&
        chatConfiguration.predatorAllCasesCode &&
        chatConfiguration.predatorSingleCaseCode
      ) {
        const startChatHistory = await PuzzelChatService.startChatHistory(
          chatConfiguration.predatorAllCasesCode,
          chatConfiguration.predatorSingleCaseCode,
          chatRequest.sourceTenantId
        );

        if (startChatHistory.success) {
          localStorage.setItem('chatNoteUnik', JSON.stringify(startChatHistory.data));
          onChatUpdate(startChatHistory.data);
        }
      }
    }
  };

  const onChatUpdate = (data: any) => {
    const intelecomMsgPnlEl = document.getElementsByClassName('intelecomMsgPnl')[0];
    const intelecomMsgPnlElChildren = intelecomMsgPnlEl.children;

    intervalOnChatUpdate = setInterval(function () {
      if (intelecomMsgPnlElChildren.length > intelecomMsgPnlElChildrenLegth) {
        const messages: UpdateMessagesType[] = [];

        for (var i = intelecomMsgPnlElChildrenLegth; i < intelecomMsgPnlElChildren.length; i++) {
          const childrenEl: any = intelecomMsgPnlElChildren[i - 1];
          let message: any;
          let timeEl: any;

          if (childrenEl.classList.contains('intelecomdialog__question')) {
            message = 'Debtor: ';
            timeEl = childrenEl.getElementsByClassName('intelecomdialog__question-time')[0];
          } else {
            message = 'Agent: ';
            timeEl = childrenEl.getElementsByClassName('intelecomdialog__answer-time')[0];
          }

          messages.push({
            message:
              message + childrenEl.querySelectorAll("[data-bind='html: Message']")[0].innerText,
            time: timeEl.innerText,
          });
        }

        intelecomMsgPnlElChildrenLegth = intelecomMsgPnlElChildren.length;

        if (chatRequest.sourceTenantId) {
          PuzzleChatApi.updateChatHistory(
            data.unik,
            data.caseGuid,
            messages,
            chatRequest.sourceTenantId
          );
        }
      }
    }, 3000);
  };

  const initalizeChat = (chatConfiguration: ChatType) => {
    // @ts-ignore
    $('#puzzelChat').intelecomChat({
      customerKey: chatConfiguration.customerKey,
      queueKey: chatConfiguration.queueKey,
      startChatImmediately: false,
      timeId: chatConfiguration.timeId,
      timeOpenExits: ['Open', 'open', 'åpent', 'Åpent'],
      visualQueueId: chatConfiguration.visualQueueId,
      nickName: chatConfiguration.nickName,
      chatId: chatConfiguration.chatId,
      languageCode: chatConfiguration.languageCode,
      visualQueueExpression: function (q: any) {
        if (!q || q.AgentsLoggedIn <= 0) {
          $('.chat-icon').hide();
        }
        return q && q.AgentsLoggedIn > 0;
      },
      onContactCenterClosed: function () {
        $('.chat-icon').hide();
      },
      showStarter: false,
      chatlink: '.chat-starter',
      onChatWindowShow: function () {
        onChatStartHandle(chatConfiguration);
        localStorage.setItem('isChatRunning', 'true');
      },
      onChatEnd: function (arg1: any, arg2: any, chatHistory: any) {
        localStorage.setItem('isChatRunning', 'false');
        clearInterval(intervalOnChatUpdate);

        intelecomMsgPnlElChildrenLegth = 1;

        chatHistory.ChatMessages.shift();
        chatHistory.ChatMessages.shift();
        chatHistory.ChatMessages.shift();

        chatHistory.ChatMessages.forEach(function (item: any) {
          const text = document.createElement('textarea');
          text.innerHTML = item.Message;
        });

        props.onCloseChat();
      },
    });
  };

  const onToggle = () => {
    props.onClose();
    setChatRequest({
      caseNo: '',
      sourceTenantId: '',
    });
  };

  const handleCaseClick = (caseSelected?: CaseType) => {
    if (caseSelected) {
      setChatRequest({
        caseNo: caseSelected.caseNo,
        sourceTenantId: caseSelected.sourceTenantId,
      });
      localStorage.setItem('puzzelChatSelectedCase', caseSelected.caseNo);
    } else {
      localStorage.setItem('puzzelChatSelectedCase', 'All Cases');
    }

    $('#chatstarter').trigger('click');

    props.onClose();
  };

  useEffect(() => {
    if (localStorage.getItem('isChatRunning') === 'true') {
      clearInterval(intervalOnChatUpdate);
    }
  }, []);

  return (
    <>
      <Modal
        isOpen={props.isShowing}
        onToggle={onToggle}
        className={classNames('scroll-1', styles.modalWrapper)}
        closeBtnClass={classNames('modal-close-btn')}
      >
        <ModuleContainer noMargin={true} variant={ModuleContainer.ModuleVariant.Box}>
          <ModuleContainer.Header title={TranslationService.translate('Cases')} />

          <ModuleContainer.Body>
            <Typography tag={Typography.Tags.H2} variant={Typography.Variants.H3}>
              <>Select a case for which you want to start a chat</>
            </Typography>

            {chatSettings.isFetching || puzzelChatCases.isFetching ? (
              <Loader opacity={0.4} />
            ) : (
              <ul className={classNames(styles.casesList)}>
                {puzzelChatCases.data?.data.displayAllCasesOption && (
                  <li onClick={() => handleCaseClick()}>
                    <div>{TranslationService.translate('AllCases')}</div>
                  </li>
                )}

                {puzzelChatCases.data?.data.cases.map((c) => (
                  <li key={c.caseNo} onClick={() => handleCaseClick(c)}>
                    <div>
                      {TranslationService.translate('Case')} {c.caseDisplayNo}
                    </div>
                    <div>
                      {c.balanceAmount} {c.currency}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </ModuleContainer.Body>
        </ModuleContainer>
      </Modal>

      <div id="puzzelChat" className="intelecomchat">
        <div id="chatstarter" className="chat-starter" />
      </div>
    </>
  );
};

export default React.memo(withAbortRequest(PuzzelChat));
